import React, { useEffect } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import { Therm } from "../ui";
import { ErrorMessage, Spinner, Logo, LogoSmall, CCAMFlag } from "../elements";

import { AnalyticsEvent } from "../../components/elements/analytics-event";
const EventMaxOverlay = (props) => {

  useEffect(() => {
        /* Remove for production */
    let eventID = props.eventId || process.env.REACT_APP_EVENT_ID;
        /* Remove for production */

    props.eventStore.eventSocketConnect(eventID);
    //props.userStore.getAccessToken();

    return () => {
      props.eventStore.eventSocketDisconnect();
    };
  }, []);

  const {
    error,
    isLoading,
    overallraised,
    overallgoalVal,
    overallprogress,
  } = props.eventStore;
  //const { accessToken } = props.userStore;

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const scrollerShow = urlParams.get("scroller");
  const scrollerPosition = urlParams.get("scrollerPosition");
  const bgColor = urlParams.get("bgColor");

  return error ? (
    <ErrorMessage>THERE HAS BEEN AN ERROR.</ErrorMessage>
  ) : isLoading ? (
    <Spinner />
  ) : (
    <div>
      <div className="max-overlay event">
        <div className="max-overlay__left small">
          <LogoSmall />
        </div>
        <div className="max-overlay__right" style={{ height: "60px" }}>
          <Therm
            raised={overallraised}
            goal={overallgoalVal}
            progress={overallprogress}
            bgColor={bgColor}
            type="event"
          />
        </div>
        {bgColor === "ccam" ? <CCAMFlag /> : ""}
      </div>
    </div>
  );
};

export default inject("eventStore")(observer(EventMaxOverlay));
